import {MessagesSquare} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const ForumIcon = createLucideIcon(MessagesSquare, 'ForumIcon');
